import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import SearchPage from '@/features/search'

const searchSchema = z.object({
  q: z.string().optional(),
  scope: z.enum(['all', 'events', 'drops', 'chats', 'users', 'lists']).optional(),
})

export const Route = createFileRoute('/_authenticated/search/')({
  component: SearchPage,
  validateSearch: searchSchema,
})
